/* global localStorage */

import { setInfoBreadcrumb } from './sentry'

let localStorageAvailable = false

try {
    localStorage.setItem('myvehicles-ls-available-test', 'test')

    if (localStorage.getItem('myvehicles-ls-available-test') === 'test') {
        localStorage.removeItem('myvehicles-ls-available-test')
        localStorageAvailable = true
    }
} catch (e) {
    // leave trace for debugging purposes
    setInfoBreadcrumb('Local storage not available...')
}

const localStorageWrapper = {
    localStorageAvailable,
    setItem: (key, val) => {
        try {
            return localStorage.setItem(key, val)
        } catch (e) {
            setInfoBreadcrumb(e)
            return null
        }
    },
    getItem: (key) => {
        try {
            return localStorage.getItem(key)
        } catch (e) {
            setInfoBreadcrumb(e)
            return null
        }
    },
    removeItem: (key) => {
        try {
            return localStorage.removeItem(key)
        } catch (e) {
            setInfoBreadcrumb(e)
            return null
        }
    },
}

window.__mv_localStorage = localStorageWrapper

export default localStorageWrapper
